<template>
	<article>
		<div class="xbed-sub-title">订单开票管理</div>
		<section class="xbed-breadcrumb">
			<Breadcrumb>
				<BreadcrumbItem>订单管理</BreadcrumbItem>
				<BreadcrumbItem>订单开票管理</BreadcrumbItem>
			</Breadcrumb>
		</section>
		<Tabs @on-click="TabGetData">
			<TabPane label="Xbed订单开票管理" name="formListData">
				<section style="margin-top:20px">
					<div class="table-cont">
						<Form inline :label-width="110" v-model="formListData" @submit.native.prevent>
							<Row>
								<Col span="24">
									<FormItem label="订单结束日期:" prop="orderEndDate">
										<DatePicker type="daterange" v-model="formListData.orderEndDate" @on-clear="clearEndDate" @on-change="dateRange => {changeDate(dateRange, 'formListData', 'orderEndDate')}" placement="bottom-start" placeholder="Select date" style="width: 200px"></DatePicker>
									</FormItem>
									<FormItem label="申请开票日期:">
										<DatePicker v-model="formListData.startDate" type="daterange" @on-change="dateRange => {changeDate(dateRange, 'formListData', 'startDate')}" placement="bottom-start" placeholder="请选择开票日期" style="width: 200px"></DatePicker>
									</FormItem>
									<FormItem label="订单号:" style="width:300px">
										<Input type="text" v-model="formListData.orderNum"></Input>
									</FormItem>
								</Col>
							</Row>
							<Row>
								<Col span="24">
									<FormItem label="来源渠道:">
										<Select v-model="formListData.channel" style="width:200px" filterable>
											<Option value="全部">全部</Option>
											<Option v-for="item in formListData.chanelData" :value="item.id" :key="item.id">{{item.name}}</Option>
										</Select>
									</FormItem>
									<FormItem label="发票类型:">
										<Select v-model="formListData.invoiceType" style="width:200px" filterable>
											<Option value="全部">全部</Option>
											<Option value="2">电子发票</Option>
											<Option value="1">纸质发票</Option>
										</Select>
									</FormItem>
									<FormItem label="开票人:" style="width:300px">
										<Input v-model="formListData.invoicePerson" type="text"></Input>
									</FormItem>
								</Col>
							</Row>
							<Row>
								<Col span="24">
									<FormItem>
										<Button type="primary" @click="queryInvoiceManageByDate">查看</Button>
										<Button type="primary" @click="queryInvoiceManageByDateExcelData">导出筛选结果</Button>
										<Button type="primary" @click="addInvoice">人工开票</Button>
									</FormItem>
								</Col>
							</Row>
						</Form>
					</div>
					<Table stripe :loading="this[currentPane].loading" :columns="currentPane == 'formListData' ? column : columnYiLong" :data="this[currentPane].list"></Table>
					<!-- <div style="margin: 10px">
						<Page placement="top" show-sizer :page-size="this[currentPane].pageSize" :total="this[currentPane].count" :current="this[currentPane].curpage" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
					</div> -->

				</section>
			</TabPane>
			<!-- <TabPane label="艺龙订单开票管理" name="formListDataYiLong">
				<section style="margin-top:20px">
					<div class="table-cont">
						<Form inline :label-width="110" v-model="formListDataYiLong" @submit.native.prevent>
							<Row>
								<Col span="24">
									<FormItem label="订单结束日期:" prop="orderEndDate">
										<DatePicker type="daterange" v-model="formListDataYiLong.orderEndDate" @on-clear="clearEndDate" @on-change="dateRange => {changeDate(dateRange, 'formListDataYiLong', 'orderEndDate')}" placement="bottom-start" placeholder="请选择订单结束日期" style="width: 200px"></DatePicker>
									</FormItem>
									<FormItem label="申请开票日期:">
										<DatePicker v-model="formListDataYiLong.startDate" type="daterange" @on-change="dateRange => {changeDate(dateRange, 'formListDataYiLong', 'startDate')}" placement="bottom-start" placeholder="请选择开票日期" style="width: 200px"></DatePicker>
									</FormItem>

								</Col>
							</Row>
							<Row>
								<Col span="24">
									<FormItem label="艺龙订单号:" style="width:300px">
										<Input type="text" v-model="formListDataYiLong.orderNum"></Input>
									</FormItem>
									<FormItem label="开票人:" style="width:300px">
										<Input v-model="formListDataYiLong.invoicePerson" type="text"></Input>
									</FormItem>

									<FormItem label="开票状态:">
										<Select v-model="formListDataYiLong.invoiceType" style="width:200px" filterable>
											<Option value="99">全部</Option>
											<Option value="98">可开票</Option>
											<Option value="1">已开票</Option>
											<Option value="0">开票中</Option>
										</Select>
									</FormItem>
								</Col>
							</Row>
							<Row>
								<Col span="24">
									<FormItem>
										<Button type="primary" @click="queryYiLongInvoiceManageByDate">查看</Button>
										<Button type="primary" :loading='this[currentPane].ButtonLoading' @click="queryYiLongInvoiceManageByDateExcelData">导出筛选结果</Button>
									</FormItem>
								</Col>
							</Row>
						</Form>
					</div>
					<Table stripe :loading="this[currentPane].loading" :columns="currentPane == 'formListData' ? column : columnYiLong" :data="this[currentPane].list"></Table>

				</section>
			</TabPane> -->
		</Tabs>
		<div style="margin: 10px">
			<Page placement="top" show-sizer :page-size="this[currentPane].pageSize" :total="this[currentPane].count" :current="this[currentPane].curpage" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
		</div>
		<Modal v-model="currentMode.isShow" :loading="true" @on-ok="submitModal" @on-cancel="cancelModel" title="客服开票" ref="invoiceModal" ok-text="提交内容">
			<Form :rules="ruleValidate" :model="currentMode" ref="inoiceForm">
				<FormItem prop="whoInvoice" label="申请开票人" :label-width="95">
					<Select v-model="currentMode.whoInvoice">
						<!-- <Option value="">请选择</Option>					  -->
						<Option v-for="item in currentMode.whoList" :value="item.v" :key="item.v">{{item.t}}</Option>
					</Select>
				</FormItem>
				<FormItem prop="remark" label="备注：" :label-width="90">
					<Input type="textarea" v-model="currentMode.remark" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入备注"></Input>
				</FormItem>
				<FormItem prop="totalRoomNight" label="房晚数量" :label-width="95">
					<Input type="text" v-model="currentMode.totalRoomNight" disabled></Input>
				</FormItem>
				<FormItem prop="monney" label="可开票金额" :label-width="95">
					<Input type="text" v-model="currentMode.monney" disabled></Input>
				</FormItem>
				<FormItem prop="realyMonney" label="开票金额" :label-width="90">
					<Input type="text" v-model="currentMode.realyMonney"></Input>
				</FormItem>
				<FormItem prop="invoiceType" label="发票类型" :label-width="90">
					<Select v-model="currentMode.invoiceType" filterable>
						<Option value="2" :key="2">电子发票</Option>
						<Option value="1" :key="1" v-if="currentPane == 'formListData'">纸质发票</Option>
					</Select>
				</FormItem>
				<FormItem prop="invoiceKindCode" label="发票种类" :label-width="90">
					<Select v-model="currentMode.invoiceKindCode" filterable>
						<Option value="82" :key="82">普票</Option>
						<Option value="81" :key="81">专票</Option>
					</Select>
				</FormItem>
				<FormItem prop="taiTouType" label="抬头类型" :label-width="90">
					<Select v-model="currentMode.taiTouType" style="" filterable>
						<Option value="1" :key="1">个人</Option>
						<Option value="2" :key="2">企业</Option>
					</Select>
				</FormItem>
				<FormItem prop="invoiceTaiTou" label="抬头" :label-width="90">
					<Input type="text" v-model="currentMode.invoiceTaiTou" placeholder="请输入抬头"></Input>
				</FormItem>
				<FormItem prop="dutyParagraph" v-if="currentMode.taiTouType =='2'" label="企业税号" :label-width="90">
					<Input type="text" v-model="currentMode.dutyParagraph" placeholder="请输入企业税号"></Input>
				</FormItem>

				<FormItem v-if="currentMode.invoiceType=='2'" prop="email" label="电子邮箱" :label-width="90">
					<Input type="text" v-model="currentMode.email" placeholder="请输入邮箱"></Input>
				</FormItem>

				<template v-if="currentMode.taiTouType=='2'">
					<FormItem prop="entAddress" label="公司地址" :label-width="90">
						<Input type="text" v-model="currentMode.entAddress" placeholder="请输入公司地址"></Input>
					</FormItem>
					<FormItem prop="entContact" label="公司电话" :label-width="90">
						<Input type="text" v-model="currentMode.entContact" placeholder="请输入公司电话"></Input>
					</FormItem>
					<FormItem prop="entDepositBank" label="公司开户行" :label-width="90">
						<Input type="text" v-model="currentMode.entDepositBank" placeholder="请输入公司开户行"></Input>
					</FormItem>
					<FormItem prop="bankAccount" label="开户行账号" :label-width="90">
						<Input type="text" v-model="currentMode.bankAccount" placeholder="请输入开户行账号"></Input>
					</FormItem>
				</template>

				<template v-if="currentMode.invoiceType=='1'">
					<FormItem prop="shouJianRen" label="收件人" :label-width="90">
						<Input type="text" v-model="currentMode.shouJianRen" placeholder="请输入收件人"></Input>
					</FormItem>
					<FormItem prop="phoneNum" label="收件手机" :label-width="90">
						<Input type="text" v-model="currentMode.phoneNum" placeholder="请输入收件人手机号"></Input>
					</FormItem>
					<FormItem prop="province" label="省份" :label-width="90">
						<Select v-model="currentMode.province" @on-change="changeProvince" label-in-value>
							<Option :value="item.id" v-for="item in provinces" :key="item.id">{{item.name}}</Option>
						</Select>
					</FormItem>
					<FormItem prop="city" label="城市" :label-width="90">
						<Select v-model="currentMode.city" @on-change="changeCity" label-in-value>
							<Option :value="item.id" v-for="item in citys" :key="item.id">{{item.name}}</Option>
						</Select>
					</FormItem>
					<FormItem prop="area" label="地区" :label-width="90">
						<Select v-model="currentMode.area" @on-change="changeArea" label-in-value>
							<Option :value="item.id" v-for="item in areas" :key="item.id">{{item.name}}</Option>
						</Select>
					</FormItem>
					<FormItem prop="street" label="街道地址" :label-width="90">
						<Input type="text" v-model="currentMode.street" placeholder="请输入街道地址"></Input>
					</FormItem>
				</template>

				<FormItem prop="invoiceRemark" label="发票备注：" :label-width="90">
					<Input type="textarea" v-model="currentMode.invoiceRemark" :autosize="{minRows: 2,maxRows: 5}" placeholder="按企业报销要求填写，如住宿时间、原因等"></Input>
				</FormItem>
			</Form>

		</Modal>
		<Modal v-model="currentInvoiceMode.isShow" :loading="true" @on-ok="submitModal" @on-cancel="cancelModel" title="人工开票" ref="invoiceModal" ok-text="提交内容">
			<Form :rules="ruleInvoiceValidate" :model="currentInvoiceMode" ref="inoiceManualForm">
        <FormItem label="开票主体" prop="invoiceConfigKey" :label-width="95">
          <Select v-model="currentInvoiceMode.invoiceConfigKey">
            <Option v-for="(item, index) in invoiceList" v-if="item" :key="index" :value="item.dictName">{{item.dictValue}}</Option>
          </Select>
        </FormItem>
				<FormItem prop="orderNoList" label="订单号" :label-width="90" placeholder="请选择订单号">
					<Select v-model="currentInvoiceMode.orderNoList" multiple filterable label-in-value :max-tag-count="5" @on-change="changeOrderNo">
						<Option v-for="(item, index) in formListData.canInvioceList" v-if="item" :key="index" :value="item">{{item.orderNo}}</Option>
					</Select>
					

	<!-- 				<Input type="textarea" v-model="currentInvoiceMode.orderNo" :autosize="{minRows: 2,maxRows: 5}" placeholder="填入订单号，多个订单号以英文逗号分开"></Input>
-->			</FormItem>
				<FormItem prop="whoInvoice" label="申请开票人" :label-width="95">
					<Select v-model="currentInvoiceMode.whoInvoice" filterable>
						<Option v-for="(item, index) in currentInvoiceMode.whoList" :value="item.v" :key="index">{{item.t}}</Option>
					</Select>
				</FormItem>
        <FormItem prop="state" label="开票状态" :label-width="90">
					<Select v-model="currentInvoiceMode.state" style="" filterable>
						<Option value="1" :key="1">开票成功</Option>
						<Option value="2" :key="2">已发送邮件</Option>
						<!-- <Option value="0" :key="0">待开票</Option> -->
					</Select>
				</FormItem>
				<FormItem prop="invoiceNo" v-if="currentInvoiceMode.state !=='0'" label="发票号码" :label-width="90">
					<Input type="text" v-model="currentInvoiceMode.invoiceNo" placeholder="发票号码"></Input>
				</FormItem>
				<FormItem prop="remark" label="备注" :label-width="90">
					<Input type="textarea" v-model="currentInvoiceMode.remark" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入备注"></Input>
				</FormItem>
				<FormItem prop="monney" label="可开票金额" :label-width="95">
					<Input type="text" v-model="currentInvoiceMode.monney" disabled></Input>
				</FormItem>
				<FormItem prop="realyMonney" label="开票金额" :label-width="90">
					<Input type="text" v-model="currentInvoiceMode.realyMonney"></Input>
				</FormItem>
				<FormItem prop="invoiceType" label="发票类型" :label-width="90">
					<Select v-model="currentInvoiceMode.invoiceType" filterable>
						<Option value="2" :key="2">电子发票</Option>
						<Option value="1" :key="1" v-if="currentPane == 'formListData'">纸质发票</Option>
					</Select>
				</FormItem>
				<FormItem prop="invoiceKindCode" label="发票种类" :label-width="90">
					<Select v-model="currentInvoiceMode.invoiceKindCode" filterable>
						<Option value="82" :key="82">普票</Option>
						<Option value="81" :key="81">专票</Option>
					</Select>
				</FormItem>
				<FormItem prop="taiTouType" label="抬头类型" :label-width="90">
					<Select v-model="currentInvoiceMode.taiTouType" style="" filterable>
						<Option value="1" :key="1">个人</Option>
						<Option value="2" :key="2">企业</Option>
					</Select>
				</FormItem>
				<FormItem prop="invoiceTaiTou" label="抬头" :label-width="90">
					<Input type="text" v-model="currentInvoiceMode.invoiceTaiTou" placeholder="请输入抬头"></Input>
				</FormItem>
				<FormItem prop="dutyParagraph" v-if="currentInvoiceMode.taiTouType =='2'" label="企业税号" :label-width="90">
					<Input type="text" v-model="currentInvoiceMode.dutyParagraph" placeholder="请输入企业税号"></Input>
				</FormItem>

				<FormItem v-if="currentInvoiceMode.invoiceType=='2'" prop="email" label="电子邮箱" :label-width="90">
					<Input type="text" v-model="currentInvoiceMode.email" placeholder="请输入邮箱"></Input>
				</FormItem>

				<template v-if="currentInvoiceMode.taiTouType=='2'">
					<FormItem prop="entAddress" label="公司地址" :label-width="90">
						<Input type="text" v-model="currentInvoiceMode.entAddress" placeholder="请输入公司地址"></Input>
					</FormItem>
					<FormItem prop="entContact" label="公司电话" :label-width="90">
						<Input type="text" v-model="currentInvoiceMode.entContact" placeholder="请输入公司电话"></Input>
					</FormItem>
					<FormItem prop="entDepositBank" label="公司开户行" :label-width="90">
						<Input type="text" v-model="currentInvoiceMode.entDepositBank" placeholder="请输入公司开户行"></Input>
					</FormItem>
					<FormItem prop="bankAccount" label="开户行账号" :label-width="90">
						<Input type="text" v-model="currentInvoiceMode.bankAccount" placeholder="请输入开户行账号"></Input>
					</FormItem>
				</template>

				<template v-if="currentInvoiceMode.invoiceType=='1'">
					<FormItem prop="shouJianRen" label="收件人" :label-width="90">
						<Input type="text" v-model="currentInvoiceMode.shouJianRen" placeholder="请输入收件人"></Input>
					</FormItem>
					<FormItem prop="phoneNum" label="收件手机" :label-width="90">
						<Input type="text" v-model="currentInvoiceMode.phoneNum" placeholder="请输入收件人手机号"></Input>
					</FormItem>
					<FormItem prop="province" label="省份" :label-width="90">
						<Select v-model="currentInvoiceMode.province" @on-change="changeProvince" label-in-value>
							<Option :value="item.id" v-for="item in provinces" :key="item.id">{{item.name}}</Option>
						</Select>
					</FormItem>
					<FormItem prop="city" label="城市" :label-width="90">
						<Select v-model="currentInvoiceMode.city" @on-change="changeCity" label-in-value>
							<Option :value="item.id" v-for="item in citys" :key="item.id">{{item.name}}</Option>
						</Select>
					</FormItem>
					<FormItem prop="area" label="地区" :label-width="90">
						<Select v-model="currentInvoiceMode.area" @on-change="changeArea" label-in-value>
							<Option :value="item.id" v-for="item in areas" :key="item.id">{{item.name}}</Option>
						</Select>
					</FormItem>
					<FormItem prop="street" label="街道地址" :label-width="90">
						<Input type="text" v-model="currentInvoiceMode.street" placeholder="请输入街道地址"></Input>
					</FormItem>
				</template>

				<FormItem prop="invoiceRemark" label="发票备注：" :label-width="90">
					<Input type="textarea" v-model="currentInvoiceMode.invoiceRemark" :autosize="{minRows: 2,maxRows: 5}" placeholder="按企业报销要求填写，如住宿时间、原因等"></Input>
				</FormItem>
			</Form>

		</Modal>
	</article>
</template>
<script>
import Moment from "moment";
import Utils from "@/utils";
import Config from "@/config";
import API from "@/api";
export default {
	async created() {
		this.token = Utils.findFromLocalStorage( "vue-token" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
    this.protHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), 
      'Authorization': Utils.findFromLocalStorage("Author-token"),
    }
    this.formHeaders = {
			'isForm': true,
      ...this.protHeaders
    }

	},
	mounted() {
		this.$Notice.config( {
			top: 60
		} );
		this.getSourceChannel();//获取来源渠道	
		this.getProvince();
		this.getInvoiceList();
	},
	methods: {
		//各标签获取数据
		TabGetData( name ) {
			this.currentPane = name;
			if ( this[name].list.length > 0 ) return;
			this.currentPane == "formListData" ? this.queryInvoiceManageByDate() : this.queryYiLongInvoiceManageByDate();
		},
		addInvoice () {
			if(this.currentPane == 'formListDataYiLong'){
				if(!Utils.hasPermission('Elong_signInvoice')){
					this.$Notice.error({
						title: '无权限操作'
					})
					return  false
				}
			}
			this.currentInvoiceMode = Object.assign( {}, this.modeBase )
			this.currentInvoiceMode.isShow = true;//显示modal
			this.currentInvoiceMode.invoiceConfigKey = "network"; //设置默认开票主体
			this.currentInvoiceMode.state = "2"; //设置默认开票状态
		},
    async getInvoiceList(){
      // 查询发票主体的字典列表
      let params = {
        pageNum: 1,
        pageSize: 10,
        groupId: 47
      }
      const resp = (await API.omsAPI[this.env].clientServer.dictValueList(params, this.protHeaders)).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '获取数据失败',
          desc: resp.msg
        })
        return
      }
      this.invoiceList = resp.list
    },
		//获取来源渠道
		async getSourceChannel() {
			this.formListData.chanelData = ( await API.omsAPI[this.env].php.queryOrderSource() ).data;
			switch ( this.formListData.chanelData.retcode ) {
				case 0:
					this.formListData.chanelData.retdata.forEach( item => {
						this.formListData.tempChanelJson[item.id + ""] = item.name;//id与来源渠道对应为了渲染数据列表方方便
					} )
					break;
				default:
					this.$Notice.error( {
						title: this.formListData.chanelData.retmsg
					} );
					break;
			}
			this.formListData.chanelData = this.formListData.chanelData.retdata;//数据驱动赋值
			this.formListData.loading = true;//数据加载中					 
			this.queryInvoiceManageByDate();//订单开票管理列表
		},

		//Xbed订单开票管理列表
		async queryInvoiceManageByDate() {
			let Obj = this.cruuentList;
			if ( !Obj.orderEndDate.length ) {
				this.$Notice.error( {title: "请至少选择一个日期"} );
				Obj.loading = false;
				return;
			}

			Obj.loading = true;
			let params = {//请求参数设置
				page: Obj.curpage,
				size: Obj.pageSize,
			};
			params.finishTimeStart = Moment( Obj.orderEndDate[0] ).format( "YYYY-MM-DD" );
			params.finishTimeEnd = Moment( Obj.orderEndDate[1] ).format( "YYYY-MM-DD" );
			params.orderNo = Obj.orderNum.trim();//订单号
			params.namePhone = Obj.invoicePerson.trim();//开票人
			params.source = Obj.channel == "全部" ? "" : Obj.channel//来源渠道
			params.invoiceType = ( Obj.invoiceType == "全部" ) ? "" : Obj.invoiceType;//发票类型
			params.issueBeginDate = "";//开票开始日期
			params.issueEndDate = "";//开票结束日期

			if ( Obj.startDate.length && Obj.startDate[0] != "" ) {
				params.issueBeginDate = Moment( Obj.startDate[0] ).format( "YYYY-MM-DD" );
				params.issueEndDate = Moment( Obj.startDate[1] ).format( "YYYY-MM-DD" );
			}

			let resp = ( await API.omsAPI[this.env].php.queryInvoiceManageByDate( params ) )//.data.data;
			let respData = resp.data.data;
			if ( resp.data.retCode == '21020000' ) {
				this.$Notice.success( {
					title: "Xbed订单查询成功"
				} );
				respData.result.forEach( item => {
					item.source = this.getchanelSource( item.source );
					item.whoList = [];
					item.checkInerJSON = {}
					item.canSign.forEach( ( ci ) => {
						item.whoList.push( {v: ci.uid, t: ci.name + ' - ' + ci.phone} );
						item.checkInerJSON[ci.uid] = {name: ci.name, phone: ci.phone};
					} )
				} )
				this.formListData.page = respData.page;
				this.formListData.count = respData.count;
				this.formListData.list = respData.result;//数据驱动赋值	
				this.formListData.canInvioceList = respData.result.filter(item => { 
					return item.canInvoice === 1 
				});//数据驱动赋值	
				this.formListData.queryParams = params;//存储params参数字段用来导出数据列表文件
				this.formListData.loading = false;	//加载结束
				//console.info(this.formListData.queryParams +"999888999888")
			} else {
				this.$Notice.error( {title: resp.data.msg} );
			}
		},

		//艺龙订单开票管理列表

		async queryYiLongInvoiceManageByDate() {

			if(!Utils.hasPermission('Elong_invoiceManage')){
				this.$Notice.error({
					title: '无权限操作'
				})
				return  false
			}
			let Obj = this.cruuentList;
			if (!Obj.orderEndDate[0] ) {
				this.$Notice.error({
					title: '请选择订单结束日期',
				})
				return
			}
			Obj.loading = true;
			let params = {//请求参数设置
				"page_num": Obj.curpage,
				"page_size": Obj.pageSize,
			};
			params['start_date'] = Moment( Obj.orderEndDate[0] ).format( "YYYY-MM-DD" );
			params['end_date'] = Moment( Obj.orderEndDate[1] ).format( "YYYY-MM-DD" );

			params['elong_order_no'] = Obj.orderNum.trim() || "";//订单号
			params['drawer_name'] = Obj.invoicePerson.trim() || "";//开票人

			params['invoice_status'] = Obj.invoiceType;//发票类型

			params['apply_invoice_start_date'] = "";//开票开始日期
			params['apply_invoice_end_date'] = "";//开票结束日期
			if ( Obj.startDate[0] ) {
				params['apply_invoice_start_date'] = Moment( Obj.startDate[0] ).format( "YYYY-MM-DD" );
				params['apply_invoice_end_date'] = Moment( Obj.startDate[1] ).format( "YYYY-MM-DD" );
			}

			let resp = ( await API.omsAPI[this.env].elong.YiLongInvoiceList( params, this.token ) ).data//.data.data;
			let respData = resp.data.list;
			this.formListDataYiLong.loading = false;	//加载结束
			if(resp.retCode !== 200 ){
				this.$Notice.error({
					title: '艺龙订单查询失败',
					desc: resp.msg
				})
				return
			} else {
				this.$Notice.success( {
					title: "艺龙订单查询成功"
				} );
				if ( respData && respData.length ) {
					respData.forEach( item => {
						if ( item.canSign ) {
							item.whoList = [];
							item.checkInerJSON = {}
							item.canSign.forEach( ( ci ) => {
								item.whoList.push( {v: ci.uid, t: ci.name + ' - ' + ci.phone} );
								item.checkInerJSON[ci.uid] = {name: ci.name, phone: ci.phone};
							} )
						} else {
							item.whoList = [{v: item.applyInvoiceUserId, t: item.creator}];
							item.checkInerJSON = {}
							item.checkInerJSON[item.applyInvoiceUserId] = {name: item.creator.split( '-' )[0], phone: item.creator.split( '-' )[1]};
						}

					} )
					this.formListDataYiLong.list = Utils.ObjectKeysTransform( {
						orign: respData,
						map: {
							"departureDate": "finishTime",
							"outOrderId": "orderNo",
							"creator": "creator",
							"totalPrice": "invoiceMoney",
							"invoiceStatus": "invoice",
							"applyInvoiceDate": "apTime",
							"applyInvoiceName": "apName",
							"invoiceType": "type",
							"invoiceNo": "invoiceNo",
							"applyInvoiceUserId": "userId"
						}
					} );//数据驱动赋值	

				}else{
					this.formListDataYiLong.list = []
				}
				this.formListDataYiLong.page = resp.pageNum;
				this.formListDataYiLong.count = resp.pageSize;
				this.formListDataYiLong.queryParams = params;//存储params参数字段用来导出数据列表文件
			} 
		},

		getchanelSource( source ) {
			return this.formListData.tempChanelJson[source + ""] === null ? "未知" : this.formListData.tempChanelJson[source + ""];
		},
		changeDate( dateRange, formName, datePicker ) {//修改设置订单结束和开票日期
			if ( !dateRange[0] ) {
				this[formName][datePicker] = [];
			} else {
				let tranferDate = [];
				for ( let i = 0; i < dateRange.length; i++ ) {
					let date = Moment( dateRange[i] ).format( "YYYY-MM-DD" );
					tranferDate.push( date );
				}
				this[formName][datePicker] = tranferDate;
			}
			//console.info(this[formName][datePicker])
		},
		changePage( page ) {//页码改变
			this[this.currentPane].curpage = page;
			this.currentPane == "formListData" ? this.queryInvoiceManageByDate() : this.queryYiLongInvoiceManageByDate();
		},
		clearEndDate() {
			this[this.currentPane].orderEndDate = [];
		},
		changePageSize( pagesize ) {//改变pageSize
			this[this.currentPane].pageSize = pagesize;
			this.currentPane == "formListData" ? this.queryInvoiceManageByDate() : this.queryYiLongInvoiceManageByDate();
		},
		changeYiLongPage( page ) {//页码改变
			this[this.currentPane].curpage = page;
			this.currentPane == "formListData" ? this.queryInvoiceManageByDate() : this.queryYiLongInvoiceManageByDate();
		},
		changeYiLongPageSize( pagesize ) {//改变pageSize
			this[this.currentPane].pageSize = pagesize;
			this.currentPane == "formListData" ? this.queryInvoiceManageByDate() : this.queryYiLongInvoiceManageByDate();
		},
		queryInvoiceManageByDateExcelData() {//导出开票列表数据				
			this.formListData.queryParams.page = 1; this.formListData.queryParams.size = 100000000;
			let url = `${ Config[this.env].phpUrl }Interface/index.php/Home/Reserve/queryInvoiceManageByDateExcelData?json_data=${ JSON.stringify( this.formListData.queryParams ) }`;
			window.open( url )
		},
		queryYiLongInvoiceManageByDateExcelData() {//导出开票列表数据	
            if (!Utils.hasPermission('Elong_orderInvoiceReport')) {
				this.$Notice.error({
				title: "无权限操作"
				});
				return
			}		
			// xzl TODO 	
			// this.formListDataYiLong.queryParams.page = 1; this.formListDataYiLong.queryParams.size = 100000000;			
			//	
			if(!this.formListDataYiLong.queryParams) {
				let Obj = this.cruuentList;
				if (!Obj.orderEndDate[0] ) {
					this.$Notice.error({
						title: '请选择订单结束日期',
					})
					return
				}
				Obj.ButtonLoading = true;
				let params = {//请求参数设置
					"page_num": Obj.curpage,
					"page_size": Obj.pageSize,
				};
				params['start_date'] = Moment( Obj.orderEndDate[0] ).format( "YYYY-MM-DD" );
				params['end_date'] = Moment( Obj.orderEndDate[1] ).format( "YYYY-MM-DD" );

				params['elong_order_no'] = Obj.orderNum.trim() || "";//订单号
				params['drawer_name'] = Obj.invoicePerson.trim() || "";//开票人

				params['invoice_status'] = Obj.invoiceType;//发票类型

				params['apply_invoice_start_date'] = "";//开票开始日期
				params['apply_invoice_end_date'] = "";//开票结束日期
				if ( Obj.startDate[0] ) {
					params['apply_invoice_start_date'] = Moment( Obj.startDate[0] ).format( "YYYY-MM-DD" );
					params['apply_invoice_end_date'] = Moment( Obj.startDate[1] ).format( "YYYY-MM-DD" );
				}
				this.formListDataYiLong.queryParams = params
			}
			let url = `${ Config[this.env].elongUrl }api/v1/elong/oms/invoice-list-export?${ Utils.queryParamsToString( this.formListDataYiLong.queryParams, ["page_num", "page_size"] ) }`;
			Utils.exportExcelWeighting( url, this.token, this.$Notice.error, this.formListDataYiLong, "ButtonLoading" )
		},
		async getProvince() {
			//if(this.formListDataMode.invoiceType == '1' &&   this.flag){
			this.flag = false;
			let resp = ( await API.omsAPI[this.env].php.provincesList() );
			this.provinces = resp.data;
			//}				
		},
		async changeProvince( obj ) {	//id：value 和 label
			let resp = ( await API.omsAPI[this.env].php.cityList( {"id": obj.value} ) );
			this.citys = resp.data;
			this.areas = []
			this[this.currentPane + "Mode"].provinceName = obj.label;
			this[this.currentPane + "Mode"].provinceId = obj.value;
		},
		async changeCity( obj ) {
			if ( obj.value == "" ) {
				return
			}
			let resp = ( await API.omsAPI[this.env].php.countyslist( {"id": obj.value} ) );
			this.areas = resp.data;
			this[this.currentPane + "Mode"].cityName = obj.label;
			this[this.currentPane + "Mode"].cityId = obj.value;
		},
		changeOrderNo( obj ) {
			console.log("chan", this.currentInvoiceMode, "=======", obj)
			this.currentInvoiceMode.whoList = []
			this.currentInvoiceMode.monney = 0.00
			this.currentInvoiceMode.totalRoomNight = 0
			obj.forEach( item => {
				console.log("option-value", item.value, item.value.invoiceMoney, item.value.whoList)
				this.currentInvoiceMode.monney += parseFloat(item.value.invoiceMoney)
				this.currentInvoiceMode.totalRoomNight += parseInt(item.value.totalRoomNight)
				this.currentInvoiceMode.whoList = Array.from(new Set([...this.currentInvoiceMode.whoList, ...item.value.whoList]))
			} )
			if(this.currentInvoiceMode.whoList.length > 0){

				var invoicePerson = this.formListData.invoicePerson != '' ? this.currentInvoiceMode.whoList.filter(item => {
					return this.formListData.invoicePerson == item.v || this.formListData.invoicePerson == item.t
				}) : []
				if(invoicePerson.length == 0){
					invoicePerson.push(this.currentInvoiceMode.whoList[0])
				}
				this.currentInvoiceMode.whoInvoice = invoicePerson[0].v
				this.currentInvoiceMode.rowDataTemp.checkInerJSON = {}
				this.currentInvoiceMode.rowDataTemp.checkInerJSON[invoicePerson[0].v] = { name: invoicePerson[0].t.split(" - ")[0], phone: invoicePerson[0].t.split(" - ")[1] }
				this.currentInvoiceMode.rowDataTemp.userId = invoicePerson[0].v
			}else{
				this.currentInvoiceMode.whoInvoice = ""
			}
			this.currentInvoiceMode.monney = this.currentInvoiceMode.monney.toFixed(2)
			this.currentInvoiceMode.realyMonney = this.currentInvoiceMode.monney
		},
		changeArea( obj ) {
			if ( obj.value == "" ) {
				return

			}
			this[this.currentPane + "Mode"].areaId = obj.value;
			this[this.currentPane + "Mode"].areaName = obj.label;
		},
		cancelModel() {//取消后初始化modal
			this.$refs.inoiceForm.resetFields()
			this.$refs.inoiceManualForm.resetFields()
		},
		submitModal() {//提交发票开取申请
			// this.validate();
			var formName = 'inoiceForm'
			if ( this.currentInvoiceMode.isShow == true) { 
				formName = 'inoiceManualForm'
			}
			this.$refs[formName].validate( ( valid ) => {
				if ( valid ) {
					// this.$refs.invoiceModal.buttonLoading = true
					let params = {};
					let mode = this.currentMode;
					if ( this.currentInvoiceMode.isShow == true ){
						mode = this.currentInvoiceMode
						mode.rowDataTemp.orderNo = mode.orderNoList.map(item => { return item.orderNo}).join(",")
						mode.rowDataTemp.invoiceMoney = mode.monney
						// mode.rowDataTemp.userId = mode.whoInvoice.userId
						params.invoiceConfigKey = mode.invoiceConfigKey
						params.state = mode.state
						params.invoiceNo = mode.invoiceNo
					}
					console.log("=========", mode)
					if(this.currentPane == 'formListData'){
						params.sourceType = 0
						params.invoiceMoney = mode.rowDataTemp.invoiceMoney;//可开票金额
						params.realMoney = mode.realyMonney;//实际用户填写的金额
						params.city = mode.cityId;//
						params.cityName = mode.cityName;//
						params.county = mode.areaId;//
						params.countyName = mode.areaName;//

						params.phone = mode.phoneNum;//填写的电话号码
						params.realname = mode.shouJianRen;//填写的收件人的姓名
						params.address = mode.street;//
											
						params.province = mode.provinceId;//
						params.provinceName = mode.provinceName;//
						params.orderNo = mode.rowDataTemp.orderNo;//订单编号
					}else{
						params.sourceType = 1
						// params.url = 'api/invoiceManage/oms/addInvoice'
						params.orderPrice = mode.rowDataTemp.invoiceMoney;//可开票金额
						params.price = mode.realyMonney;//实际用户填写的金额
						params.orderNo = mode.rowDataTemp.orderId;//订单编号
					}

					console.log('params========params111111', params)
		
					params.userId = mode.rowDataTemp.userId || 1;
					params.applyName = mode.rowDataTemp.checkInerJSON[mode.whoInvoice].name//开票人的名字
					params.applyPhone = mode.rowDataTemp.checkInerJSON[mode.whoInvoice].phone;//开票人的电话
					params.remark = mode.remark;//用户填的备注

					params.invoiceType = mode.invoiceType;//发票类型纸质1；电子2
					params.invoiceKindCode = mode.invoiceKindCode;//发票种类专票81；普票82
					params.titleType = mode.taiTouType;//抬头类型个人1，企业2
					params.title = mode.invoiceTaiTou;//发票抬头
					params.taxpayerId = mode.dutyParagraph;//企业税号
					params.email = mode.email;//填写的邮件

					params.price = parseFloat( mode.realyMonney * 100 );//
					params.orderPrice = parseFloat( mode.monney * 100 );
					params.account = this.username
					params.totalRoomNight = mode.totalRoomNight
					params.invoiceRemark = mode.invoiceRemark

					if (mode.taiTouType == 2) {
						params.entAddress = mode.entAddress
						params.entContact = mode.entContact
						params.entDepositBank = mode.entDepositBank
						params.bankAccount = mode.bankAccount
					}

					console.log('params========', params)
					
					// return 
					this.sendModal( params )
				}
				this.$refs.invoiceModal.buttonLoading = false
				
			} )
		},
		async sendModal( params ) {
			let resp
			if(this.currentPane == "formListData"){
				if(this.currentInvoiceMode.isShow == true){
					API.omsAPI[this.env].clientServer.invoiceRegister(params, this.formHeaders).then((res) => {
						var data = res.data;
						if (data.retCode && data.retCode !== 21020000 && data.retCode !== 200) {
							this.$Notice.error({
								title: data.msg
							});
						} else {
							this.currentInvoiceMode.isShow = false;
								this.$Notice.success( {title: "操作成功！"} );
								this.cruuentList.loading = true
								setTimeout(()=> this.queryInvoiceManageByDate(),2000)
						}
					})	
				}else{
					resp = ( await API.omsAPI[this.env].php.signInvoice( params ) ).data
					if ( resp.retCode === 21020000 ) {
						this[this.currentPane+"Mode"].isShow = false;
						this.$Notice.success( {title: "操作成功！"} );
						this.cruuentList.loading = true
						setTimeout(()=>this.currentPane == "formListData" ? this.queryInvoiceManageByDate() : this.queryYiLongInvoiceManageByDate(),2000)
					} else {
						this.$Notice.error( {title: resp.msg || resp.retmsg} );
					}
				}
			}else{
				resp = (await API.omsAPI[this.env].order.signInvoice( params,this.token )).data
				if ( resp.retCode) {
					this.$Notice.error( {title: resp.msg || resp.retmsg} );
				} else {
					this[this.currentPane+"Mode"].isShow = false;
					this.$Notice.success( {title: "操作成功！"} );
					this.cruuentList.loading = true
					setTimeout(()=>this.currentPane == "formListData" ? this.queryInvoiceManageByDate() : this.queryYiLongInvoiceManageByDate(),2000)
				}
			}
			this.$refs.invoiceModal.buttonLoading = false
		},
		validat( a, value, callback ) {
			let money = Number( value );
			let reg = /^\d+(\.\d{1,2})?$/g;
			if ( !reg.test( money ) ) {
				callback( new Error( '开票金额格式不对,同时最多保留小数点2位' ) );
			}
			if ( Number( value ) > this.currentMode.monney && Number( value ) == this.currentMode.realyMonney ) {
				callback( new Error( '不可大于可开票金额' ) )
			}
			//电子发票	
			// if ( this.currentMode.invoiceType == 2 && Number( value ) > 9999.99 ) {
			// 	callback( new Error( '开票金额1万以上，仅支持纸质发票' ) )
			// }
			callback();
		},
		dutyValid( a, value, callback ) {
			let reg1 = /^([A-Za-z0-9]{15})$/
			let reg2 = /^([A-Za-z0-9]{18})$/
			let reg3 = /^([A-Za-z0-9]{20})$/
			if ( reg1.test( value ) || reg2.test( value ) || reg3.test( value ) ) {
				callback();
			} else {
				callback( new Error( '请输入15、18或20位的企业税号' ) )
			}
		},
		tableRander( h, params ) {
			if ( params.row.canInvoice ) {
				return h( "div", {
					style: {
						"background-color": "#2d8cf0", padding: "2px 2px", color: "#fff", cursor: "pointer"
					},
					on: {
						click: () => {
						if(this.currentPane == 'formListDataYiLong'){
							if(!Utils.hasPermission('Elong_signInvoice')){
								this.$Notice.error({
									title: '无权限操作'
								})
								return  false
							}
						}
							this[this.currentPane + "Mode"] = Object.assign( {}, this.modeBase )
							this.currentMode.isShow = true;//显示modal

							this.currentMode.whoList = params.row.whoList;//设置申请开票人
							this.currentMode.realyMonney = params.row.invoiceMoney;//设置实际开票金额
							this.currentMode.monney = params.row.invoiceMoney;//设置设置可开票金额
							this.currentMode.whoInvoice = params.row.whoList[0].v;//设置默认选择第一个开票人
							this.currentMode.remark = params.row.remark;//设置默认选择第一个开票人
							this.currentMode.rowDataTemp = params.row;
							this.currentMode.totalRoomNight = params.row.totalRoomNight;
						}
					}
				}, '客服开票' );
			}
		}
	},
	computed: {
		currentMode() {
			return this[this.currentPane + "Mode"]
		},
		cruuentList() {
			return this[this.currentPane]
		}
	},
	data() {
		let defaultDate = [Moment().subtract( 15, "days" ).format( "YYYY-MM-DD" ), Moment().format( "YYYY-MM-DD" )];
		return {
			currentPane: "formListData",
			currentInvoiceMode: {},
			invoiceList: [],
			provinces:[],
				citys: [],
				areas: [],
			formListData: {
				chanelData: [],
				pageSize: 10,
				invoiceType: '全部',
				channel: "全部",
				orderEndDate: defaultDate,
				startDate: [],
				orderNum: '',
				invoicePerson: '',
				list: [],
				canInvioceList: [],
				count: 0,
				curpage: 1,
				loading: false,
				downLoading:false,
				tempChanelJson: {}
			},
			formListDataYiLong: {
				chanelData: [],
				pageSize: 10,
				invoiceType: '99',
				channel: "全部",
				orderEndDate: defaultDate,
				startDate: [],
				orderNum: '',
				invoicePerson: '',
				list: [],
				count: 0,
				curpage: 1,
				loading: false,
				downLoading:false,
				tempChanelJson: {},
				ButtonLoading: false
			},
			formListDataMode: {
				isShow: false,
			},
			formListDataYiLongMode: {
				isShow: false,
			},
			modeBase: {
				isShow: true,
				whoInvoice: "",
				whoList: [],
				remark: '',
				monney: 0,
				realyMonney: 0,
				invoiceType: "2",
				invoiceKindCode: "82",
				taiTouType: "1",
				invoiceTaiTou: "",
				dutyParagraph: '',
				email: '',
				shouJianRen: '',
				phoneNum: '',
				province: "null",
				city: 'null',
				area: "null",

				provinceId:"",
				provinceName:"",//
				cityId:"",//
				cityName:"",//
				areaId:"",//
				areaName:"",

				street: '',
				rowDataTemp: {}
			},
			ruleValidate: {
				whoInvoice: [
					{required: true, type: 'number', message: '不能为空', trigger: 'change'}
				],
				remark: [
					{required: true, message: '备注不能为空', trigger: 'blur'}
				],
				realyMonney: [
					//{required:true,trigger:'blur'},//formListDataMode.monney
					{required: true, trigger: 'blur', validator: this.validat}
				],
				invoiceTaiTou: [
					{required: true, message: '抬头不能为空', trigger: 'blur'}
				],
				dutyParagraph: [
					{required: true, message: '企业税号不能为空', trigger: 'blur'}
				],
				email: [
					{required: true, message: '邮箱不能为空', trigger: 'blur'},
					{pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: '邮箱格式不正确', trigger: 'blur'}

				],
				shouJianRen: [
					{required: true, message: '收件人不能为空', trigger: 'blur'}
				],
				phoneNum: [
					{required: true, message: '电话号码不能为空', trigger: 'blur'},
					{pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '手机号格式不正确', trigger: 'blur'}
				],
				street: [
					{required: true, message: '街道地址不能为空', trigger: 'blur'}
				],
				invoiceType: [
					{required: true, trigger: 'blur'}
				],
				taiTouType: [
					{required: true, trigger: 'blur'}
				],
				province: [
					{required: true, type: 'number', message: '省份不能为空', trigger: 'blur'},
				],
				city: [
					{required: true, type: 'number', message: '城市不能为空', trigger: 'blur'}
				],
				area: [
					{required: true, type: 'number', message: '地区不能为空', trigger: 'blur'}
				],
				entContact: [
					{pattern: /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/, message: '公司电话格式不正确', trigger: 'blur'}
				],
				// totalRoomNight: [
				// 	{required: true, message: '房晚数量不能为空', trigger: 'blur'}
				// ],
			},
			ruleInvoiceValidate: {
				whoInvoice: [
					{required: true, type: 'number', message: '不能为空', trigger: 'change'}
				],
				orderNoList: [
					{required: true, type: 'array', message: '不能为空', trigger: 'change'}
				],
				remark: [
					{required: true, message: '备注不能为空', trigger: 'blur'}
				],
				realyMonney: [
					//{required:true,trigger:'blur'},//formListDataMode.monney
					{required: true, trigger: 'blur', validator: this.validat}
				],
				invoiceTaiTou: [
					{required: true, message: '抬头不能为空', trigger: 'blur'}
				],
				dutyParagraph: [
					{required: true, message: '企业税号不能为空', trigger: 'blur'},
					{validator: this.dutyValid, trigger: 'blur'},
				],
				invoiceNo: [
					{required: true, message: '发票号码不能为空', trigger: 'blur'}
				],
				email: [
					{required: true, message: '邮箱不能为空', trigger: 'blur'},
					{pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/, message: '邮箱格式不正确', trigger: 'blur'}

				],
				shouJianRen: [
					{required: true, message: '收件人不能为空', trigger: 'blur'}
				],
				phoneNum: [
					{required: true, message: '电话号码不能为空', trigger: 'blur'},
					{pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/, message: '手机号格式不正确', trigger: 'blur'}
				],
				street: [
					{required: true, message: '街道地址不能为空', trigger: 'blur'}
				],
				invoiceType: [
					{required: true, trigger: 'blur'}
				],
				taiTouType: [
					{required: true, trigger: 'blur'}
				],
				province: [
					{required: true, type: 'number', message: '省份不能为空', trigger: 'blur'},
				],
				city: [
					{required: true, type: 'number', message: '城市不能为空', trigger: 'blur'}
				],
				area: [
					{required: true, type: 'number', message: '地区不能为空', trigger: 'blur'}
				],
				entContact: [
					{pattern: /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/, message: '公司电话格式不正确', trigger: 'blur'}
				],
				// totalRoomNight: [
				// 	{required: true, message: '房晚数量不能为空', trigger: 'blur'}
				// ],
			},
			column: [
				{
					title: "订单结束时间",
					key: "finishTime",
					align: "center",
					width: 200
				},
				{
					title: "订单号",
					key: "orderNo",
					align: "center",
					width: 210
				},
				{
					title: "入住单",
					key: "checkinIds",
					align: "center",
					width: 150
				},
				{
					title: "来源渠道",
					key: "source",
					align: "center",
					width: 200
				},
				{
					title: "渠道单号",
					key: "otherNo",
					align: "center",
					width: 100
				},
				{
					title: "预订人",
					align: "center",
					width: 200,
					render: ( h, params ) => {
						return h( "span", {}, `${ params.row.name }-${ params.row.phone }` );
					}
				},
				{
					title: "已入住入住人",
					align: "center",
					width: 200,
					render: ( h, params ) => {
						let obj = {};
						let len = params.row.checkIner.length;
						if ( len ) {
							for ( var i = 0; i < len; i++ ) obj.checkInerText = params.row.checkIner[i].name + ' - ' + params.row.checkIner[i].phone;
						} else {
							obj.checkInerText = " - ";
						}
						return h( "span", {}, `${ obj.checkInerText }` );
					}
				},
				{
					title: "可开票金额",
					key: 'invoiceMoney',
					align: "center",
					width: 200
				},
				{
					title: "开票状态",
					key: 'invoice',
					align: "center",
					width: 100
				},
				{
					title: "申请开票时间",
					key: 'apTime',
					align: "center",
					width: 200
				},
				{
					title: "申请开票人",
					key: 'apName',
					align: "center",
					width: 150
				},
				{
					title: "发票类型",
					key: 'type',
					align: "center",
					width: 100
				},
				{
					title: "发票号码",
					key: 'invoiceNo',
					align: "center",
					width: 100
				},
				{
					title: "备注",
					key: 'remark',
					align: "center",
					width: 100
				},
				{
					title: "操作",
					align: "center",
					width: 100,
					render: ( h, params ) => this.tableRander( h, params )
				}
			],
			columnYiLong: [
				{
					title: "订单结束时间",
					key: "finishTime",
					align: "center",
					width: 200
				},
				{
					title: "艺龙订单号",
					key: "orderNo",
					align: "center",
					width: 210
				},
				{
					title: "预订人",
					key: 'creator',
					align: "center",
					width: 200
				},
				{
					title: "可开票金额",
					key: 'invoiceMoney',
					align: "center",
					width: 200
				},
				{
					title: "开票状态",
					key: 'invoice',
					align: "center",
					width: 100,
					render: ( h, params ) => {
						if ( params.row.invoice == 98 ) params.row.canInvoice = true
						return h( 'span', {}, ( {98: "可开票", 0: "开票中", 1: "已开票"} )[params.row.invoice] )
					}

				},
				{
					title: "申请开票时间",
					key: 'apTime',
					align: "center",
					width: 200
				},
				{
					title: "申请开票人",
					key: 'apName',
					align: "center",
					width: 150
				},
				{
					title: "开票类型",
					key: 'type',
					align: "center",
					width: 100,
					render: ( h, params ) => {
						return h( 'span', {}, ['', '纸质发票', '电子发票'][params.row.type] )
					}
				},
				{
					title: "发票号码",
					key: 'invoiceNo',
					align: "center",
					width: 100
				},
				{
					title: "备注",
					key: 'remark',
					align: "center",
					width: 100
				},
				{
					title: "操作",
					align: "center",
					width: 100,
					render: ( h, params ) => this.tableRander( h, params )
				}
			],

		}
	}

}
</script>







// WEBPACK FOOTER //
// src/pages/order/invoiceManage.vue